<template>
  <UiModalShell :show="show" :title="title" size="sm" @close="!loading && $emit('cancel')">
    <p class="text-[13px] text-text-2 leading-relaxed">{{ message }}</p>
    <template #footer>
      <UiButton variant="ghost" :disabled="loading" @click="$emit('cancel')">
        {{ cancelText }}
      </UiButton>
      <UiButton :variant="confirmVariant" :loading="loading" @click="$emit('confirm')">
        {{ confirmText }}
      </UiButton>
    </template>
  </UiModalShell>
</template>

<script setup>
import { computed } from 'vue';
import UiModalShell from '@/components/ui/UiModalShell.vue';
import UiButton from '@/components/ui/UiButton.vue';

const props = defineProps({
  show:        { type: Boolean, required: true },
  title:       { type: String, default: 'Confirm' },
  message:     { type: String, required: true },
  confirmText: { type: String, default: 'Confirm' },
  cancelText:  { type: String, default: 'Cancel' },
  type:        { type: String, default: 'info' }, // info | warning | danger
  loading:     { type: Boolean, default: false },
});
defineEmits(['confirm', 'cancel']);

const confirmVariant = computed(() => ({
  info: 'primary',
  warning: 'warning',
  danger: 'danger',
}[props.type] || 'primary'));
</script>
